import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { Formik, Form } from "formik";
import Button from "../../../Components/Button/Button";
import { EnumEstadoEventoConcesion, EnumPathRutas } from "../../../Utils/Enumeradores/ComunEnum";
import { useToast } from "../../../Hooks/useToast";
import { validarExtensionArchivo, sinExtension, TamanoArchivo } from "../../../Utils/Validations/Validations";
import useLogin from "../../Autenticacion/Hooks/useLogin";
import { ListaSolicitudReprocesoService } from "../Services/ListaSolicitudReprocesoService";
import { ObtenerEventoConcesionService } from "../Services/ObtenerEventoConcesionService";
import { SolicitudReprocesoService } from "../Services/SolicitudReprocesoService";
import { ListaPeriodosCalculosService } from "../../Indicadores/Services/ListaPeriodosCalculosService";
import "./SolicitudReprocesosPage.css";

const ReprocessSelectOption = (props) => {
	const { innerProps, isSelected, label } = props;

	return (
		<div {...innerProps} className={`datamart-filter-toolbar__option ${isSelected ? "is-selected" : ""}`}>
			<span className="datamart-filter-toolbar__radio" aria-hidden="true"></span>
			<span>{label}</span>
		</div>
	);
};

const SOLICITUDES_INICIALES = [];

const EVENTOS_INICIALES = [];

const EVENTOS_DETALLE_SOLICITUD = [
	[
		{
			idSicbs: "2.147.483.101",
			descripcion: "LCV - Longitud de colas de vehículos",
			medicion: "90",
			fechaCreacion: "14-05-2024 08:09:16",
			fechaMedicion: "14-05-2024 08:09:16",
			observacion: "Lorem ipsum dolor sit amet consectetur. In quis ac pellentesque ultricies enim pretium. Condimentum lorem imperdiet vel convallis sapien amet semper aliquet.",
			estadoEventoOrigen: "Incumplimiento",
			estadoEventoSolicitado: "Cumplimiento",
			estadoAutorizacionOrigen: "Aprobado",
			estadoAutorizacionSolicitado: "–",
		},
		{
			idSicbs: "2.147.483.647",
			descripcion: "LCV - Longitud de colas de vehículos",
			medicion: "90",
			fechaCreacion: "14-05-2024 08:09:16",
			fechaMedicion: "14-05-2024 08:09:16",
			observacion: "Lorem ipsum dolor sit amet consectetur. I",
			estadoEventoOrigen: "Incumplimiento",
			estadoEventoSolicitado: "–",
			estadoAutorizacionOrigen: "Aprobado",
			estadoAutorizacionSolicitado: "Rechazado",
		},
	],
	[
		{
			idSicbs: "2.147.483.094",
			descripcion: "LCV - Longitud de colas de vehículos",
			medicion: "100",
			fechaCreacion: "14-05-2024 08:09:16",
			fechaMedicion: "14-05-2024 08:09:16",
			observacion: "",
			estadoEventoOrigen: "Incumplimiento",
			estadoEventoSolicitado: "–",
			estadoAutorizacionOrigen: "Aprobado",
			estadoAutorizacionSolicitado: "–",
		},
		{
			idSicbs: "2.147.483.435",
			descripcion: "LCV - Longitud de colas de vehículos",
			medicion: "90",
			fechaCreacion: "14-05-2024 08:09:16",
			fechaMedicion: "14-05-2024 08:09:16",
			observacion: "",
			estadoEventoOrigen: "Cumplimiento",
			estadoEventoSolicitado: "–",
			estadoAutorizacionOrigen: "Aprobado",
			estadoAutorizacionSolicitado: "–",
		},
	],
];

const PAGINACION_SOLICITUDES = {
	numeroPagina: 1,
	cantidadRegistros: 10,
	orderByAscending: false,
	ordenadoPor: ""
};

const MONTH_NAMES = {
	1: "Enero",
	2: "Febrero",
	3: "Marzo",
	4: "Abril",
	5: "Mayo",
	6: "Junio",
	7: "Julio",
	8: "Agosto",
	9: "Septiembre",
	10: "Octubre",
	11: "Noviembre",
	12: "Diciembre",
};

const formatSolicitudDate = (value) => {
	if (!value) {
		return "";
	}

	if (typeof value === "string" && value.includes("/") && value.includes(":")) {
		return value;
	}

	const parsedDate = new Date(value);
	if (Number.isNaN(parsedDate.getTime())) {
		return value;
	}

	const pad = (dateValue) => String(dateValue).padStart(2, "0");
	return `${pad(parsedDate.getDate())}/${pad(parsedDate.getMonth() + 1)}/${parsedDate.getFullYear()} ${pad(parsedDate.getHours())}:${pad(parsedDate.getMinutes())}:${pad(parsedDate.getSeconds())}`;
};

const getTipoEstadoSolicitud = (estado) => {
	const normalizedEstado = (estado || "").toString().trim().toLowerCase();

	if (normalizedEstado.includes("proceso")) {
		return "proceso";
	}

	if (normalizedEstado.includes("termin")) {
		return "terminada";
	}

	if (normalizedEstado.includes("fall")) {
		return "fallo";
	}

	return "gris";
};

const getMonthLabel = (solicitud) => {
	const rawMonth = solicitud?.nombreMes ?? solicitud?.mesNombre ?? solicitud?.mesDescripcion ?? solicitud?.mes;

	if (typeof rawMonth === "string" && Number.isNaN(Number(rawMonth))) {
		return rawMonth;
	}

	return MONTH_NAMES[Number(rawMonth)] || rawMonth || "";
};

const mapSolicitudEventosDetalle = (eventos = []) => {
	const eventosNormalizados = eventos.map((evento) => ({
		idSicbs: evento?.eventoConcesionId ?? evento?.idSicbs ?? evento?.idSicns ?? "",
		descripcion: evento?.descripcion ?? "",
		medicion: evento?.medicion ?? evento?.valor ?? "",
		fechaCreacion: formatSolicitudDate(evento?.fechaCreacion ?? ""),
		fechaMedicion: formatSolicitudDate(evento?.fechaHoraMedicion ?? evento?.fechaMedicion ?? ""),
		observacion: evento?.observacionSolicitada ?? evento?.observacion ?? "",
		estadoEventoOrigen: evento?.estadoEventoOrigenDescripcion ?? evento?.estadoEventoOrigen ?? "",
		estadoEventoSolicitado: evento?.estadoEventoSolicitadoDescripcion ?? evento?.estadoEventoSolicitado ?? "",
		estadoAutorizacionOrigen: normalizarEstadoAutorizacion(evento?.estadoAutorizacionOrigen, evento?.estadoAutorizacionOrigenDescripcion),
		estadoAutorizacionSolicitado: normalizarEstadoAutorizacion(evento?.estadoAutorizacionSolicitado, evento?.estadoAutorizacionSolicitadoDescripcion),
	}));

	return eventosNormalizados.reduce((paginas, evento, index) => {
		const pagina = Math.floor(index / 2);

		if (!paginas[pagina]) {
			paginas[pagina] = [];
		}

		paginas[pagina].push(evento);
		return paginas;
	}, []);
};

const normalizarEstadoEvento = (evento) => {
	if (typeof evento?.estadoEvento === "boolean") {
		return evento.estadoEvento ? "Cumplimiento" : "Incumplimiento";
	}

	if (typeof evento?.estadoEventoDescripcion === "string" && evento.estadoEventoDescripcion.trim()) {
		return evento.estadoEventoDescripcion.trim();
	}

	if (typeof evento?.estadoDescripcion === "string" && evento.estadoDescripcion.trim()) {
		return evento.estadoDescripcion.trim();
	}

	return "Incumplimiento";
};

const normalizarEstadoAutorizacion = (estadoAutorizacion, estadoAutorizacionDescripcion) => {
	if (typeof estadoAutorizacionDescripcion === "string" && estadoAutorizacionDescripcion.trim()) {
		const descripcion = estadoAutorizacionDescripcion.trim();

		if (descripcion === "Autorizado" || descripcion === "Autorizada") {
			return "Aprobado";
		}

		return descripcion;
	}

	const estadoNumerico = Number(estadoAutorizacion);

	if (estadoNumerico === EnumEstadoEventoConcesion.Autorizado) {
		return "Aprobado";
	}

	if (estadoNumerico === EnumEstadoEventoConcesion.Rechazado) {
		return "Rechazado";
	}

	if (estadoNumerico === EnumEstadoEventoConcesion.Pendiente) {
		return "Pendiente";
	}

	return "Aprobado";
};

const construirDescripcionEvento = (evento) => {
	const sigla = evento?.siglaIndicador?.trim?.() || "";
	const descripcion = evento?.descripcionIndicador?.trim?.() || evento?.descripcion?.trim?.() || "";

	if (sigla && descripcion) {
		return `${sigla} - ${descripcion}`;
	}

	return sigla || descripcion;
};

const mapEventoConcesion = (evento) => ({
	idSicns: evento?.eventoConcesionId ?? "",
	eventoConcesionId: evento?.eventoConcesionId ?? "",
	descripcion: construirDescripcionEvento(evento),
	medicion: evento?.valor ?? "",
	fechaCreacion: formatSolicitudDate(evento?.fechaCreacion ?? ""),
	fechaMedicion: formatSolicitudDate(evento?.fechaHora1 ?? evento?.fechaHora2 ?? ""),
	estadoEvento: normalizarEstadoEvento(evento),
	estadoAutorizacion: normalizarEstadoAutorizacion(
		evento?.estadoAutorizacion ?? evento?.estado,
		evento?.estadoAutorizacionDescripcion ?? evento?.estadoDescripcion
	),
	observacion: evento?.observacion ?? "",
});

const mapSolicitudReproceso = (solicitud) => ({
	id: solicitud?.idSolicitud ?? solicitud?.solicitudReprocesoId ?? solicitud?.solicitudId ?? solicitud?.id ?? "",
	usuario: solicitud?.usuarioCreacion ?? solicitud?.nombreUsuarioCreacion ?? solicitud?.usuario ?? solicitud?.nombreUsuario ?? solicitud?.idUsuarioCreacion ?? "",
	fecha: formatSolicitudDate(solicitud?.fechaCreacion ?? solicitud?.fechaHoraCreacion ?? solicitud?.fecha ?? ""),
	ano: solicitud?.anio ?? solicitud?.ano ?? "",
	mes: getMonthLabel(solicitud),
	estado: solicitud?.estado ?? solicitud?.nombreEstado ?? "",
	tipoEstado: getTipoEstadoSolicitud(solicitud?.estado ?? solicitud?.nombreEstado),
	documentos: Array.isArray(solicitud?.documentos) ? solicitud.documentos.map((documento) => ({
		id: documento?.documentoAdjuntoId ?? documento?.id ?? `${documento?.nombre ?? "documento"}-${documento?.ruta ?? ""}`,
		nombre: documento?.nombre ?? "",
		fecha: formatSolicitudDate(documento?.fechaCreacion ?? ""),
		usuario: documento?.usuario ?? "",
		ruta: documento?.ruta ?? "",
	})) : [],
	eventosDetalle: Array.isArray(solicitud?.eventos) ? mapSolicitudEventosDetalle(solicitud.eventos) : [],
});

const obtenerEstadoEventoRequest = (estadoEvento) => estadoEvento === "Cumplimiento";

const obtenerEstadoAutorizacionRequest = (estadoAutorizacion) =>
	estadoAutorizacion === "Rechazado"
		? EnumEstadoEventoConcesion.Rechazado
		: EnumEstadoEventoConcesion.Autorizado;

const SolicitudReprocesosPage = () => {
	const formikRef = useRef(null);
	const addToast = useToast();
	const { user, usuario } = useLogin();
	const idUsuario = user?.id || usuario?.id;
	const [actualizarEvento, setActualizarEvento] = useState(false);
	const [idSicns, setIdSicns] = useState("");
	const [eventos, setEventos] = useState(EVENTOS_INICIALES);
	const [eventoObservacion, setEventoObservacion] = useState(null);
	const [estadoEventoModal, setEstadoEventoModal] = useState("Cumplimiento");
	const [estadoAutorizacionModal, setEstadoAutorizacionModal] = useState("Aprobado");
	const [observacionModal, setObservacionModal] = useState("Lorem ipsum dolor sit amet consectetur.");
	const [eventoEliminar, setEventoEliminar] = useState(null);
	const [mostrarModalReprocesar, setMostrarModalReprocesar] = useState(false);
	const [mostrarModalSolicitudExitosa, setMostrarModalSolicitudExitosa] = useState(false);
	const [solicitudes, setSolicitudes] = useState(SOLICITUDES_INICIALES);
	const [solicitudDetalle, setSolicitudDetalle] = useState(null);
	const [detalleEventosAbierto, setDetalleEventosAbierto] = useState(true);
	const [detallePaginaEventos, setDetallePaginaEventos] = useState(0);
	const [detalleSecciones, setDetalleSecciones] = useState({});
	const [valoresFormulario, setValoresFormulario] = useState(null);
	const [listadoPeriodos, setListadoPeriodos] = useState([]);
	const [isAddingEvento, setIsAddingEvento] = useState(false);
	const isAgregarEventoDisabled = idSicns.trim().length === 0;

	const aniosPeriodo = [...new Set(listadoPeriodos.map((item) => item.ano))]
		.sort((a, b) => b - a);

	const aniosOptions = aniosPeriodo.map((ano) => ({
		value: ano,
		label: ano
	}));

	const reprocessSelectComponents = { Option: ReprocessSelectOption };

	const obtenerPeriodoMasReciente = (periodos = []) => {
		if (periodos.length === 0) {
			return null;
		}

		return [...periodos].sort((a, b) => {
			if (b.ano !== a.ano) {
				return b.ano - a.ano;
			}

			return b.mes - a.mes;
		})[0];
	};

	const obtenerUltimoMesPorAno = (ano) => {
		const periodosAno = listadoPeriodos.filter((item) => item.ano === Number(ano));
		return obtenerPeriodoMasReciente(periodosAno);
	};

	const obtenerMesesOptions = (ano) => listadoPeriodos
		.filter((item) => item.ano === Number(ano))
		.sort((a, b) => a.mes - b.mes)
		.map((item) => ({
			value: item.mes,
			label: item.nombreMes
		}));

	async function postListaPeriodosCalculosService() {
		if (!idUsuario) {
			return;
		}

		const resp = await ListaPeriodosCalculosService({ idUsuario });
		if (resp && resp.status === 200 && Array.isArray(resp.data)) {
			setListadoPeriodos(resp.data);
		}
	}

	async function postListaSolicitudReprocesoService() {
		if (!idUsuario) {
			return;
		}

		const formEnvio = {
			paginacion: PAGINACION_SOLICITUDES,
			datosBusqueda: {
				idUsuario
			}
		};

		const resp = await ListaSolicitudReprocesoService(formEnvio);
		if (resp && resp.status === 200) {
			const listadoSolicitudes = Array.isArray(resp.data)
				? resp.data
				: resp.data?.listaResultado ?? resp.data?.resultado ?? resp.data?.data ?? [];
			setSolicitudes(Array.isArray(listadoSolicitudes) ? listadoSolicitudes.map(mapSolicitudReproceso) : []);
		}
	}

	useEffect(() => {
		postListaPeriodosCalculosService();
		postListaSolicitudReprocesoService();
	}, [idUsuario]);

	useEffect(() => {
		const values = formikRef.current?.values;
		if (!values?.ano || !values?.mes) {
			setActualizarEvento(false);
		}
	}, [formikRef.current?.values?.ano, formikRef.current?.values?.mes]);

	const handlerFiles = (event, values, setFieldValue, setFieldError) => {
		const file = event.target.files?.[0];
		if (!file) return;

		const extValido = validarExtensionArchivo(file, ['pdf', 'doc', 'docx']);
		if (extValido) {
			setFieldError('archivos', extValido);
			return;
		}

		const extError = sinExtension(file);
		if (extError) {
			setFieldError('archivos', extError);
			return;
		}

		const tamError = TamanoArchivo(file);
		if (tamError) {
			setFieldError('archivos', tamError);
			return;
		}

		const archivosActuales = values.archivos || [];
		if (archivosActuales.length >= 5) {
			setFieldError('archivos', 'Solo se puede adjuntar hasta 5 archivos');
			return;
		}

		setFieldValue('archivos', [...archivosActuales, file]);
		setFieldError('archivos', undefined);
	};

	const handleSubmit = (values) => {
		if (actualizarEvento && eventos.length === 0) {
			addToast({
				mostrar: true,
				mensaje: "Debe cargar registros para actualizar",
				titulo: "Información",
				tipo: "Info",
			});
			return;
		}

		setValoresFormulario(values);
		setMostrarModalReprocesar(true);
	};

	const resetFormularioReproceso = () => {
		setMostrarModalReprocesar(false);
		setActualizarEvento(false);
		setValoresFormulario(null);
		setIdSicns("");
		setEventos(EVENTOS_INICIALES);

		if (formikRef.current) {
			formikRef.current.resetForm();
		}
	};

	const validarFormularioReproceso = (values) => {
		const errors = {};
		if (!values.ano) errors.ano = 'Requerido';
		if (!values.mes) errors.mes = 'Requerido';
		return errors;
	};

	const abrirModalObservacion = (evento) => {
		setEventoObservacion(evento);
		setEstadoEventoModal(evento.estadoEvento === "Cumplimiento" ? "Cumplimiento" : "Incumplimiento");
		setEstadoAutorizacionModal(evento.estadoAutorizacion === "Aprobado" ? "Aprobado" : "Rechazado");
		setObservacionModal(evento.observacion || "");
	};

	const cerrarModalObservacion = () => {
		setEventoObservacion(null);
	};

	const limpiarModalObservacion = () => {
		setEstadoEventoModal("Cumplimiento");
		setEstadoAutorizacionModal("Aprobado");
		setObservacionModal("");
	};

	const guardarModalObservacion = () => {
		if (!eventoObservacion) {
			return;
		}

		setEventos((prev) =>
			prev.map((evento) => {
				if (evento !== eventoObservacion) {
					return evento;
				}

				return {
					...evento,
					estadoEventoOrigen: evento.estadoEventoOrigen || evento.estadoEvento,
					estadoAutorizacionOrigen: evento.estadoAutorizacionOrigen || evento.estadoAutorizacion,
					estadoEvento: estadoEventoModal,
					estadoAutorizacion: estadoAutorizacionModal,
					observacion: observacionModal,
				};
			})
		);
		setEventoObservacion(null);
	};

	const agregarEventoVisual = async (archivos = [], values = {}) => {
		if (!Array.isArray(archivos) || archivos.length === 0) {
			addToast({
				mostrar: true,
				mensaje: "Es necesario cargar un archivo antes de agregar eventos a actualizar.",
				titulo: "Información",
				tipo: "Info",
			});
			return;
		}

		const idSicnsLimpio = idSicns.trim();

		if (!idSicnsLimpio) {
			return;
		}

		const eventoDuplicado = eventos.some(
			(evento) => String(evento?.idSicns ?? "").trim() === idSicnsLimpio
		);

		if (eventoDuplicado) {
			addToast({
				mostrar: true,
				mensaje: "El ID SICNS ingresado ya existe en la grilla.",
				titulo: "Información",
				tipo: "Info",
			});
			return;
		}

		if (!values?.ano || !values?.mes) {
			return;
		}

		const profileContextId = usuario?.perfilContexto?.id || user?.perfilContexto?.id || 0;
		const payload = {
			idUsuario: Number(idUsuario || 0),
			idPerfilContexto: Number(profileContextId),
			idEventoConcesion: Number(idSicnsLimpio),
			anio: Number(values.ano),
			mes: Number(values.mes),
		};

		setIsAddingEvento(true);

		try {
			const resp = await ObtenerEventoConcesionService(payload);
			const eventoData = Array.isArray(resp?.data) ? resp.data[0] : resp?.data;
			const mensajeBackend = resp?.data?.mensaje;
			const codigoBackend = resp?.data?.codigo;

			if (resp?.status !== 200 || codigoBackend === 206 || !eventoData || mensajeBackend) {
				if ((resp?.status !== 200 || !eventoData) && !mensajeBackend && codigoBackend !== 206) {
					addToast({
						mostrar: true,
						mensaje: "No fue posible obtener la información del evento ingresado.",
						titulo: "Información",
						tipo: "Info",
					});
				}

				return;
			}

			if (eventoData?.eventoConcesionId === undefined || eventoData?.eventoConcesionId === null) {
				addToast({
					mostrar: true,
					mensaje: "No fue posible obtener la información del evento ingresado.",
					titulo: "Información",
					tipo: "Info",
				});
				return;
			}

			setEventos((prev) => [...prev, mapEventoConcesion(eventoData)]);
			setIdSicns("");
		} catch (error) {
			addToast({
				mostrar: true,
				mensaje: "Ha ocurrido un error al consultar el evento, favor intente más tarde.",
				titulo: "Error",
				tipo: "Danger",
			});
		} finally {
			setIsAddingEvento(false);
		}
	};

	const eliminarEventoVisual = () => {
		setEventos((prev) => prev.filter((evento) => evento !== eventoEliminar));
		setEventoEliminar(null);
	};

	const mapearEventosDetalle = (eventosSolicitud) => {
		const eventosNormalizados = eventosSolicitud.map((evento) => ({
			idSicbs: evento.idSicns,
			descripcion: evento.descripcion,
			medicion: evento.medicion,
			fechaCreacion: evento.fechaCreacion,
			fechaMedicion: evento.fechaMedicion,
			observacion: evento.observacion || "",
			estadoEventoOrigen: evento.estadoEventoOrigen || evento.estadoEvento,
			estadoEventoSolicitado: evento.estadoEvento,
			estadoAutorizacionOrigen: evento.estadoAutorizacionOrigen || evento.estadoAutorizacion,
			estadoAutorizacionSolicitado: evento.estadoAutorizacion,
		}));

		return eventosNormalizados.reduce((paginas, evento, index) => {
			const pagina = Math.floor(index / 2);

			if (!paginas[pagina]) {
				paginas[pagina] = [];
			}

			paginas[pagina].push(evento);
			return paginas;
		}, []);
	};

	const confirmarReprocesarVisual = async () => {
		if (!actualizarEvento) {
			const values = valoresFormulario || {};
			const listaArchivos = Array.isArray(values.archivos) ? values.archivos : [];
			const formEnvio = {
				idUsuarioCreacion: idUsuario,
				anio: values.ano,
				mes: values.mes,
				listaArchivos: listaArchivos,
			};

			const resp = await SolicitudReprocesoService(formEnvio);
			if (resp?.data?.codigo === 206) {
				setMostrarModalReprocesar(false);
				return;
			}

			if (!resp || resp.status !== 200 || resp.data !== true) {
				addToast({
					mostrar: true,
					mensaje: "Ha ocurrido un error, favor intente más tarde.",
					titulo: "Error",
					tipo: "Danger",
				});
				setMostrarModalReprocesar(false);
				return;
			}

			resetFormularioReproceso();
			postListaSolicitudReprocesoService();
			setMostrarModalSolicitudExitosa(true);
			return;
		}

		const values = valoresFormulario || {};
		const listaArchivos = Array.isArray(values.archivos) ? values.archivos : [];
		const detalleReprocesoEventos = eventos.map((evento) => ({
			eventoConcesionId: Number(evento.eventoConcesionId ?? evento.idSicns ?? 0),
			estadoEventoSolicitado: obtenerEstadoEventoRequest(evento.estadoEvento),
			estadoAutorizacionSolicitado: obtenerEstadoAutorizacionRequest(evento.estadoAutorizacion),
			observacion: evento.observacion || "",
		}));
		const formEnvio = {
			idUsuarioCreacion: idUsuario,
			anio: values.ano,
			mes: values.mes,
			listaArchivos,
			detalleReprocesoEventos,
		};

		const resp = await SolicitudReprocesoService(formEnvio);
		if (resp?.data?.codigo === 206) {
			setMostrarModalReprocesar(false);
			return;
		}

		if (!resp || resp.status !== 200 || resp.data !== true) {
			addToast({
				mostrar: true,
				mensaje: "Ha ocurrido un error, favor intente más tarde.",
				titulo: "Error",
				tipo: "Danger",
			});
			setMostrarModalReprocesar(false);
			return;
		}

		resetFormularioReproceso();
		postListaSolicitudReprocesoService();
		setMostrarModalSolicitudExitosa(true);
	};

	const abrirDetalleSolicitud = (solicitud) => {
		setSolicitudDetalle(solicitud);
		setDetalleEventosAbierto(true);
		setDetallePaginaEventos(0);
		setDetalleSecciones({});
	};

	const cerrarDetalleSolicitud = () => {
		setSolicitudDetalle(null);
	};

	const paginasEventosDetalle = Array.isArray(solicitudDetalle?.eventosDetalle)
		? solicitudDetalle.eventosDetalle
		: [];

	const eventosPaginaActualDetalle = paginasEventosDetalle[detallePaginaEventos] || [];

	const cambiarPaginaDetalle = (direccion) => {
		setDetallePaginaEventos((prev) => {
			const next = prev + direccion;
			return Math.min(Math.max(next, 0), paginasEventosDetalle.length - 1);
		});
	};

	const estaSeccionDetalleAbierta = (eventoId, seccion) => {
		const key = `${eventoId}-${seccion}`;

		if (Object.prototype.hasOwnProperty.call(detalleSecciones, key)) {
			return detalleSecciones[key];
		}

		return detallePaginaEventos === 0;
	};

	const toggleSeccionDetalle = (eventoId, seccion) => {
		const key = `${eventoId}-${seccion}`;
		setDetalleSecciones((prev) => ({
			...prev,
			[key]: !estaSeccionDetalleAbierta(eventoId, seccion),
		}));
	};

	const obtenerClaseEstado = (estado) => {
		if (estado === "Aprobado" || estado === "Cumplimiento") {
			return "reprocess-status--aprobado";
		}

		if (estado === "Incumplimiento" || estado === "Rechazado") {
			return "reprocess-status--incumplimiento";
		}

		return "reprocess-status--gris";
	};

	const renderActionIcon = (type) => {
		if (type === "signature") {
			return (
				<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
					<path d="M42 33.9995L37.688 30.2635C37.5455 30.1284 37.3663 30.0382 37.1729 30.0043C36.9795 29.9703 36.7803 29.9941 36.6003 30.0725C36.4202 30.151 36.2673 30.2808 36.1606 30.4457C36.0538 30.6105 35.998 30.8032 36 30.9995V31.9995C36 32.53 35.7893 33.0387 35.4142 33.4138C35.0391 33.7888 34.5304 33.9995 34 33.9995H30C29.4696 33.9995 28.9609 33.7888 28.5858 33.4138C28.2107 33.0387 28 32.53 28 31.9995C28 26.9095 20.018 24.0595 11 23.9995C9.67392 23.9995 8.40215 24.5263 7.46447 25.464C6.52678 26.4017 6 27.6735 6 28.9995C6 30.3256 6.52678 31.5974 7.46447 32.5351C8.40215 33.4728 9.67392 33.9995 11 33.9995C19.306 33.9995 20.49 11.4095 22.416 6.99954C22.7414 6.25513 23.2432 5.60121 23.8781 5.09436C24.513 4.58752 25.2619 4.24301 26.0599 4.09066C26.8579 3.93831 27.681 3.9827 28.4579 4.21999C29.2349 4.45728 29.9424 4.88032 30.5191 5.45251C31.0958 6.0247 31.5244 6.72879 31.7678 7.50388C32.0112 8.27896 32.0621 9.10169 31.9161 9.90086C31.77 10.7 31.4314 11.4516 30.9296 12.0905C30.4278 12.7293 29.7778 13.2363 29.036 13.5675M6 41.9995H42" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			);
		}

		if (type === "pdf") {
			return (
				<svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
					<path d="M4 1.5H17L26.5 11V28C26.5 29.38 25.38 30.5 24 30.5H4C2.62 30.5 1.5 29.38 1.5 28V4C1.5 2.62 2.62 1.5 4 1.5Z" stroke="currentColor" strokeWidth="1.6" />
					<path d="M17 2V11H26" stroke="currentColor" strokeWidth="1.6" />
					<path d="M7 23C10 21.5 12 17.5 13 13C14.2 18 16.8 21 21 22.5C17.8 21.7 12.5 21.7 7 23Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			);
		}

		if (type === "receipt") {
			return (
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
					<path d="M4 2.5H12V13.5L10.5 12.5L9 13.5L7.5 12.5L6 13.5L4 12.2V2.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M6.25 6H10.25M6.25 8.25H9.25" stroke="currentColor" strokeLinecap="round" />
				</svg>
			);
		}

		if (type === "square-check") {
			return (
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
					<rect x="2.5" y="2.5" width="11" height="11" rx="2" stroke="currentColor" />
					<path d="M5.5 8L7.25 9.75L10.75 6.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			);
		}

		if (type === "edit") {
			return (
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
					<path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M12.25 1.75015C12.5152 1.48493 12.8749 1.33594 13.25 1.33594C13.6251 1.33594 13.9848 1.48493 14.25 1.75015C14.5152 2.01537 14.6642 2.37508 14.6642 2.75015C14.6642 3.12522 14.5152 3.48493 14.25 3.75015L8.24136 9.75948C8.08305 9.91765 7.88749 10.0334 7.67269 10.0962L5.75735 10.6562C5.69999 10.6729 5.63918 10.6739 5.58129 10.6591C5.52341 10.6442 5.47057 10.6141 5.42832 10.5719C5.38607 10.5296 5.35595 10.4768 5.34112 10.4189C5.32629 10.361 5.32729 10.3002 5.34402 10.2428L5.90402 8.32748C5.96704 8.11285 6.08304 7.91752 6.24136 7.75948L12.25 1.75015Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			);
		}

		if (type === "delete") {
			return (
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
					<path d="M6.66667 7.33398V11.334M9.33333 7.33398V11.334M12.6667 4.00065V13.334C12.6667 13.6876 12.5262 14.0267 12.2761 14.2768C12.0261 14.5268 11.687 14.6673 11.3333 14.6673H4.66667C4.31304 14.6673 3.97391 14.5268 3.72386 14.2768C3.47381 14.0267 3.33333 13.6876 3.33333 13.334V4.00065M2 4.00065H14M5.33333 4.00065V2.66732C5.33333 2.3137 5.47381 1.97456 5.72386 1.72451C5.97391 1.47446 6.31304 1.33398 6.66667 1.33398H9.33333C9.68696 1.33398 10.0261 1.47446 10.2761 1.72451C10.5262 1.97456 10.6667 2.3137 10.6667 2.66732V4.00065" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			);
		}

		return (
			<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
				<path d="M14.6667 11.3333C14.6667 11.687 14.5262 12.0261 14.2762 12.2761C14.0261 12.5262 13.687 12.6667 13.3334 12.6667H4.55204C4.19845 12.6667 3.85936 12.8073 3.60937 13.0573L2.14137 14.5253C2.07518 14.5915 1.99084 14.6366 1.89903 14.6548C1.80722 14.6731 1.71206 14.6637 1.62558 14.6279C1.5391 14.5921 1.46518 14.5314 1.41316 14.4536C1.36115 14.3758 1.33339 14.2843 1.33337 14.1907V3.33333C1.33337 2.97971 1.47385 2.64057 1.7239 2.39052C1.97395 2.14048 2.31309 2 2.66671 2H13.3334C13.687 2 14.0261 2.14048 14.2762 2.39052C14.5262 2.64057 14.6667 2.97971 14.6667 3.33333V11.3333Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M4.66663 7.33398H11.3333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M4.66663 10H8.66663" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M4.66663 4.66602H9.99996" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		);
	};

	return (
		<>
		<div className="container-fluid">
			<div className="row mb-4">
				<div className="col-12">
					<div className="breadcrumbs">
						<ul>
							<li>
								<Link to={EnumPathRutas.Inicio}>Inicio</Link>
							</li>
							<li>
								<Link to={EnumPathRutas.Configuracion}>Configuración</Link>
							</li>
							<li>
								<a href="#">Solicitud de reprocesos</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-12">
					<section className="reprocess-card">
						<Formik
							innerRef={formikRef}
							initialValues={{ ano: "", mes: "", archivos: [] }}
							validate={validarFormularioReproceso}
							onSubmit={handleSubmit}
						>
							{({ values, setFieldValue, setFieldError, errors }) => {
								const mesesOptions = obtenerMesesOptions(values.ano);
								const isPeriodoSeleccionado = Boolean(values.ano && values.mes);

								return (
							<Form>
						<div className="reprocess-form">
							<h2 className="reprocess-title">Nueva solicitud de reproceso</h2>

							<div className="reprocess-form__body">
								<div className="reprocess-form__controls align-items-start">
									<div className="form-floating">
										<div className="simple-select reprocess-select">
											<label htmlFor="reprocess-year">Año</label>
											<Select
												classNamePrefix="selector"
												inputId="reprocess-year"
												name="ano"
												options={aniosOptions}
												value={aniosOptions.find((option) => option.value === Number(values.ano)) || null}
												onChange={(option) => {
													const ano = option ? option.value : "";
													const ultimoMes = obtenerUltimoMesPorAno(ano);

													setFieldValue('ano', ano);
													setFieldValue('mes', ultimoMes ? ultimoMes.mes : "");
												}}
												placeholder="Seleccionar"
												noOptionsMessage={() => "Sin opciones"}
												isSearchable={false}
												components={reprocessSelectComponents}
												isDisabled={aniosOptions.length === 0}
											/>
										</div>
									</div>

									<div className="form-floating">
										<div className="simple-select reprocess-select">
											<label htmlFor="reprocess-month">Mes</label>
											<Select
												classNamePrefix="selector"
												inputId="reprocess-month"
												name="mes"
												options={mesesOptions}
												value={mesesOptions.find((option) => option.value === Number(values.mes)) || null}
												onChange={(option) => setFieldValue('mes', option ? option.value : "")}
												placeholder="Seleccionar"
												noOptionsMessage={() => "Sin opciones"}
												isSearchable={false}
												components={reprocessSelectComponents}
												isDisabled={mesesOptions.length === 0}
											/>
										</div>
									</div>

									<div className="form-floating">
										<button
											type="button"
											className="reprocess-upload"
											onClick={() => {
												const input = document.getElementById('reprocess-file-input');
												if (input) input.click();
											}}
										>
											<span>Subir archivo</span>
											<i className="ico-upload" aria-hidden="true"></i>
										</button>
										<input
											id="reprocess-file-input"
											type="file"
											accept=".pdf,.doc,.docx"
											multiple
											className="d-none"
											onChange={(event) => {
												handlerFiles(event, values, setFieldValue, setFieldError);
												event.target.value = '';
											}}
										/>
										{errors.archivos && (
											<small className="message" style={{ color: '#dc3545', fontSize: '12px', width: '100%' }}>{errors.archivos}</small>
										)}										
									</div>

									{values.archivos && values.archivos.length > 0 && (
										<div className="d-flex flex-wrap" style={{ gap: '16px', width: '100%' }}>
											{values.archivos.map((file, index) => (
												<div className="reprocess-file" key={`${file.name}-${index}`}>
													<i className="ico-doc-empty" aria-hidden="true"></i>
													<div className="reprocess-file__text">
														<strong>{file.name}</strong>
														<span>{(file.size / 1024).toFixed(2)} KB</span>
													</div>
													<button type="button" onClick={() => {
														const nuevos = values.archivos.filter((_, i) => i !== index);
														setFieldValue('archivos', nuevos);
													}} aria-label="Quitar archivo">
														<i className="ico-close" aria-hidden="true"></i>
													</button>
												</div>
											))}
										</div>
									)}
								</div>

								<label className="reprocess-radio">
									<input
										type="radio"
										checked={actualizarEvento}
										disabled={!isPeriodoSeleccionado}
										onClick={() => setActualizarEvento((prev) => !prev)}
										onChange={() => {}}
									/>
									<span>Actualizar evento</span>
								</label>

								{actualizarEvento && (
									<div className="reprocess-events">
										<div className="reprocess-events__toolbar">
											<div className="reprocess-id-field">
												<input
													id="reprocess-id-sicns"
													className="reprocess-id-field__input"
													value={idSicns}
													onChange={(event) => setIdSicns(event.target.value)}
													placeholder="Ingresar"
												/>
												<label htmlFor="reprocess-id-sicns">ID SICNS</label>
												{idSicns && (
													<button
														type="button"
														className="reprocess-id-field__clear"
														onClick={() => setIdSicns("")}
														aria-label="Limpiar ID SICNS"
													>
														<span aria-hidden="true"></span>
													</button>
												)}
											</div>
											<Button
												type="button"
												design="btn-primary reprocess-add"
												onClick={() => agregarEventoVisual(values.archivos, values)}
												disabled={isAgregarEventoDisabled || isAddingEvento}
											>
												{isAddingEvento ? "Agregando..." : "Agregar"}
											</Button>
										</div>

										<div className="table-responsive">
											<table className="table reprocess-table reprocess-table--events">
												<thead>
													<tr>
														<th><span className="d-flex align-items-center gap-1">Id SICNS <i className="ico-sort fs-7"></i></span></th>
														<th><span className="d-flex align-items-center gap-1">Descripción <i className="ico-sort fs-7"></i></span></th>
														<th><span className="d-flex align-items-center gap-1">Medición <i className="ico-sort fs-7"></i></span></th>
														<th><span className="d-flex align-items-center gap-1">Fecha creación <i className="ico-sort fs-7"></i></span></th>
														<th><span className="d-flex align-items-center gap-1">Fecha/Hora medición <i className="ico-sort fs-7"></i></span></th>
														<th className="text-center"><span className="d-flex align-items-center justify-content-center gap-1">Estado evento <i className="ico-sort fs-7"></i></span></th>
														<th className="text-center"><span className="d-flex align-items-center justify-content-center gap-1">Estado autorización <i className="ico-sort fs-7"></i></span></th>
														<th className="text-center">Observación</th>
														<th className="text-center">Acción</th>
													</tr>
												</thead>
												<tbody>
													{eventos.map((evento, index) => (
														<tr key={`${evento.idSicns}-${index}`}>
															<td>{evento.idSicns}</td>
															<td>{evento.descripcion}</td>
															<td>{evento.medicion}</td>
															<td>{evento.fechaCreacion}</td>
															<td>{evento.fechaMedicion}</td>
															<td className="text-center">
																<span className={`reprocess-status ${evento.estadoEvento === "Cumplimiento" ? "reprocess-status--cumplimiento" : "reprocess-status--incumplimiento"}`}>
																	{evento.estadoEvento}
																</span>
															</td>
															<td className="text-center">
																<span className={`reprocess-status ${evento.estadoAutorizacion === "Aprobado" ? "reprocess-status--aprobado" : "reprocess-status--rechazado"}`}>
																	{evento.estadoAutorizacion}
																</span>
															</td>
															<td className="text-center">
																<button type="button" className="reprocess-action" aria-label={`Ver observación ${evento.idSicns}`} onClick={() => abrirModalObservacion(evento)}>
																	{renderActionIcon("comment")}
																</button>
															</td>
															<td className="text-center">
																<div className="reprocess-actions">
																	<button type="button" className="reprocess-action" aria-label={`Editar evento ${evento.idSicns}`} onClick={() => abrirModalObservacion(evento)}>
																		{renderActionIcon("edit")}
																	</button>
																	<button type="button" className="reprocess-action" aria-label={`Eliminar evento ${evento.idSicns}`} onClick={() => setEventoEliminar(evento)}>
																		{renderActionIcon("delete")}
																	</button>
																</div>
															</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
								)}
							</div>

							<div className="reprocess-form__footer">
								<Button
									type="submit"
									design="btn-primary reprocess-submit"
									disabled={!values.ano || !values.mes}
								>
									Reprocesar
								</Button>
							</div>
						</div>
						</Form>
								);
							}}
						</Formik>

						<div className="reprocess-table-header">
							<div className="reprocess-update">
								<span className="reprocess-update__icon" aria-hidden="true"></span>
								<span>Última actualización de solicitudes hace 5 minutos</span>
							</div>
						</div>

						<div className="table-responsive">
							<table className="table reprocess-table">
								<thead>
									<tr>
										<th><span className="d-flex align-items-center gap-1">ID Solicitud <i className="ico-sort fs-7"></i></span></th>
										<th><span className="d-flex align-items-center gap-1">Usuario creación <i className="ico-sort fs-7"></i></span></th>
										<th><span className="d-flex align-items-center gap-1">Fecha creación <i className="ico-sort fs-7"></i></span></th>
										<th><span className="d-flex align-items-center gap-1">Año <i className="ico-sort fs-7"></i></span></th>
										<th><span className="d-flex align-items-center gap-1">Mes <i className="ico-sort fs-7"></i></span></th>
										<th className="text-center"><span className="d-flex align-items-center justify-content-center gap-1">Estado <i className="ico-sort fs-7"></i></span></th>
										<th className="text-center">Detalle</th>
									</tr>
								</thead>
								<tbody>
									{solicitudes.map((solicitud, index) => (
										<tr key={`${solicitud.id}-${index}`}>
											<td>{solicitud.id}</td>
											<td>{solicitud.usuario}</td>
											<td>{solicitud.fecha}</td>
											<td>{solicitud.ano}</td>
											<td>{solicitud.mes}</td>
											<td className="text-center">
												<span className={`reprocess-status reprocess-status--${solicitud.tipoEstado}`}>
													{solicitud.estado}
												</span>
											</td>
											<td className="text-center">
												<button type="button" className="reprocess-detail" aria-label={`Ver detalle solicitud ${solicitud.id}`} onClick={() => abrirDetalleSolicitud(solicitud)}>
													<i className="ico-search" aria-hidden="true"></i>
												</button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</section>
				</div>
			</div>
		</div>
		<Modal
			show={mostrarModalSolicitudExitosa}
			onHide={() => setMostrarModalSolicitudExitosa(false)}
			centered
		>
			<Modal.Body>
				<div className='info my-4'>
					<h6 className='info__title'>Solicitud</h6>
					<p className='info__text'>Se ha generado la solicitud de reproceso correctamente.</p>
				</div>
				<div className="d-flex flex-column flex-md-row justify-content-center align-items-stretch align-items-md-center gap-4">
					<Button type="button" design="btn-primary btn--small" onClick={() => setMostrarModalSolicitudExitosa(false)}>Aceptar</Button>
				</div>
			</Modal.Body>
		</Modal>
		<Modal
			show={Boolean(eventoObservacion)}
			onHide={cerrarModalObservacion}
			centered
			dialogClassName="reprocess-observation-modal"
			contentClassName="reprocess-observation-modal__content"
		>
			<Modal.Body className="reprocess-observation-modal__body">
				<div className="reprocess-observation-modal__header">
					<h3>Actualizar evento: [Id SICNS {eventoObservacion?.idSicns}]</h3>
					<button type="button" className="reprocess-modal-close" onClick={cerrarModalObservacion} aria-label="Cerrar">
						<i className="ico-close" aria-hidden="true"></i>
					</button>
				</div>

				<div className="reprocess-observation-modal__content-inner">
					<div className="reprocess-modal-section">
						<p>Actualizar estado de evento</p>
						<div className="reprocess-modal-radio-group">
							<label className="reprocess-modal-radio">
								<input
									type="radio"
									name="estado-evento-modal"
									checked={estadoEventoModal === "Cumplimiento"}
									onChange={() => setEstadoEventoModal("Cumplimiento")}
								/>
								<span>Cumplimiento</span>
							</label>
							<label className="reprocess-modal-radio">
								<input
									type="radio"
									name="estado-evento-modal"
									checked={estadoEventoModal === "Incumplimiento"}
									onChange={() => setEstadoEventoModal("Incumplimiento")}
								/>
								<span>Incumplimiento</span>
							</label>
						</div>
					</div>

					<div className="reprocess-modal-section">
						<p>Actualizar estado de autorización</p>
						<div className="reprocess-modal-radio-group">
							<label className="reprocess-modal-radio">
								<input
									type="radio"
									name="estado-autorizacion-modal"
									checked={estadoAutorizacionModal === "Aprobado"}
									onChange={() => setEstadoAutorizacionModal("Aprobado")}
								/>
								<span>Aprobado</span>
							</label>
							<label className="reprocess-modal-radio">
								<input
									type="radio"
									name="estado-autorizacion-modal"
									checked={estadoAutorizacionModal === "Rechazado"}
									onChange={() => setEstadoAutorizacionModal("Rechazado")}
								/>
								<span>Rechazado</span>
							</label>
						</div>
					</div>

					<div className="reprocess-modal-field">
						<input
							id="reprocess-observacion-modal"
							value={observacionModal}
							onChange={(event) => setObservacionModal(event.target.value.slice(0, 200))}
							maxLength={200}
						/>
						<label htmlFor="reprocess-observacion-modal">Observación</label>
						<small>Quedan {200 - observacionModal.length} caracteres disponibles</small>
					</div>
				</div>

				<div className="reprocess-observation-modal__footer">
					<Button type="button" design="btn--outline btn--pewter-blue reprocess-modal-btn" onClick={limpiarModalObservacion}>
						Limpiar
					</Button>
					<Button type="button" design="btn-primary reprocess-modal-btn" onClick={guardarModalObservacion}>
						Confirmar
					</Button>
				</div>
			</Modal.Body>
		</Modal>
		<Modal
			show={Boolean(eventoEliminar)}
			onHide={() => setEventoEliminar(null)}
			centered
			dialogClassName="reprocess-delete-modal"
			contentClassName="reprocess-delete-modal__content"
		>
			<Modal.Body className="reprocess-delete-modal__body">
				<div className="reprocess-delete-modal__header">
					<button type="button" className="reprocess-modal-close" onClick={() => setEventoEliminar(null)} aria-label="Cerrar">
						<i className="ico-close" aria-hidden="true"></i>
					</button>
				</div>

				<div className="reprocess-delete-modal__message">
					<div className="reprocess-delete-modal__icon">
						{renderActionIcon("delete")}
					</div>
					<div className="reprocess-delete-modal__text">
						<h3>¿Estás seguro?</h3>
						<p>Al eliminar la actualización se borrara el evento seleccionado.</p>
					</div>
				</div>

				<div className="reprocess-delete-modal__footer">
					<Button type="button" design="btn--outline btn--pewter-blue reprocess-modal-btn" onClick={() => setEventoEliminar(null)}>
						Cancelar
					</Button>
					<Button type="button" design="btn-primary reprocess-delete-confirm" onClick={eliminarEventoVisual}>
						Eliminar
					</Button>
				</div>
			</Modal.Body>
		</Modal>
		<Modal
			show={mostrarModalReprocesar}
			onHide={() => setMostrarModalReprocesar(false)}
			centered
			dialogClassName="reprocess-confirm-modal"
			contentClassName="reprocess-confirm-modal__content"
		>
			<Modal.Body className="reprocess-confirm-modal__body">
				<div className="reprocess-confirm-modal__header">
					<button type="button" className="reprocess-modal-close" onClick={() => setMostrarModalReprocesar(false)} aria-label="Cerrar">
						<i className="ico-close" aria-hidden="true"></i>
					</button>
				</div>

				<div className="reprocess-confirm-modal__message">
					<div className="reprocess-confirm-modal__icon">
						{renderActionIcon("signature")}
					</div>
					<div className="reprocess-confirm-modal__text">
						<h3>¿Estás seguro?</h3>
						<p>Presiona “Continuar” para confirmar y reprocesar</p>
					</div>
				</div>

				<div className="reprocess-confirm-modal__footer">
					<Button type="button" design="btn--outline btn--pewter-blue reprocess-confirm-review" onClick={() => setMostrarModalReprocesar(false)}>
						Volver a revisar
					</Button>
					<Button type="button" design="btn-primary reprocess-confirm-action" onClick={confirmarReprocesarVisual}>
						Confirmar
					</Button>
				</div>
			</Modal.Body>
		</Modal>
		<Modal
			show={Boolean(solicitudDetalle)}
			onHide={cerrarDetalleSolicitud}
			centered
			dialogClassName="reprocess-detail-modal"
			contentClassName="reprocess-detail-modal__content"
		>
			<Modal.Body className="reprocess-detail-modal__body">
				<div className="reprocess-detail-modal__header">
					<span className={`reprocess-status reprocess-status--${solicitudDetalle?.tipoEstado || "proceso"}`}>
						{solicitudDetalle?.estado || "En proceso"}
					</span>
					<button type="button" className="reprocess-modal-close" onClick={cerrarDetalleSolicitud} aria-label="Cerrar">
						<i className="ico-close" aria-hidden="true"></i>
					</button>
				</div>

				<div className="reprocess-detail-modal__scroll">
					<div className="reprocess-detail-modal__title">
						<strong>{solicitudDetalle?.id}</strong>
						<span>Id solicitud</span>
					</div>

					<section className="reprocess-detail-section">
						<h3>Detalle de solicitud de reproceso</h3>
						<div className="reprocess-detail-data">
							<p><strong>Usuario creación:</strong> {solicitudDetalle?.usuario}</p>
							<p><strong>Fecha creación:</strong> {solicitudDetalle?.fecha}</p>
							<p><strong>Año:</strong> {solicitudDetalle?.ano}</p>
							<p><strong>Mes:</strong> {solicitudDetalle?.mes}</p>
						</div>
					</section>

					<section className="reprocess-detail-section">
						<h3>Documentos</h3>
						{(solicitudDetalle?.documentos?.length ?? 0) > 0 ? (
							solicitudDetalle.documentos.map((documento) => (
								<div className="reprocess-detail-document" key={documento.id}>
									<span className="reprocess-detail-document__icon">{renderActionIcon("pdf")}</span>
									<div>
										<strong>
											{documento.ruta ? (
												<a
													href={documento.ruta}
													target="_blank"
													rel="noreferrer"
													download
												>
													{documento.nombre}
												</a>
											) : (
												documento.nombre
											)}
										</strong>
										<p>Agregado por <strong>{documento.usuario || "Sin usuario"}</strong>{documento.fecha ? ` ${documento.fecha}` : ""}</p>
									</div>
								</div>
							))
						) : (
							<div className="reprocess-detail-document">
								<span className="reprocess-detail-document__icon">{renderActionIcon("pdf")}</span>
								<div>
									<strong>Sin documentos</strong>
									<p>No existen documentos adjuntos para esta solicitud.</p>
								</div>
							</div>
						)}
					</section>

					<section className="reprocess-detail-section reprocess-detail-section--events">
						<button type="button" className="reprocess-detail-collapse" onClick={() => setDetalleEventosAbierto((prev) => !prev)}>
							<span>Eventos</span>
							<i className={`ico-chevron-down ${detalleEventosAbierto ? "is-open" : ""}`} aria-hidden="true"></i>
						</button>

						{detalleEventosAbierto && (
							<>
								{paginasEventosDetalle.length > 0 ? (
									<>
										<div className="reprocess-detail-pager">
											<button type="button" className="reprocess-detail-nav" disabled={detallePaginaEventos === 0} onClick={() => cambiarPaginaDetalle(-1)} aria-label="Eventos anteriores">
												<span aria-hidden="true">‹</span>
											</button>
											<div className="reprocess-detail-page">
												<span>{detallePaginaEventos + 1} de {paginasEventosDetalle.length}</span>
												<strong>{detallePaginaEventos + 1}</strong>
											</div>
											<button type="button" className="reprocess-detail-nav" disabled={detallePaginaEventos === paginasEventosDetalle.length - 1} onClick={() => cambiarPaginaDetalle(1)} aria-label="Eventos siguientes">
												<span aria-hidden="true">›</span>
											</button>
										</div>

										<div className="reprocess-detail-events-grid">
											{eventosPaginaActualDetalle.map((evento) => {
												const observacionAbierta = estaSeccionDetalleAbierta(evento.idSicbs, "observacion");
												const solicitudAbierta = estaSeccionDetalleAbierta(evento.idSicbs, "solicitud");

												return (
													<article className="reprocess-detail-event-card" key={evento.idSicbs}>
														<div className="reprocess-detail-event-summary">
															<div>
																<span>Id SICBS</span>
																<strong>{evento.idSicbs}</strong>
															</div>
														</div>
														<div className="reprocess-detail-event-grid">
															<div>
																<span>Descripción</span>
																<p>{evento.descripcion}</p>
															</div>
															<div>
																<span>Medición</span>
																<p>{evento.medicion}</p>
															</div>
															<div>
																<span>Fecha de creación</span>
																<p>{evento.fechaCreacion}</p>
															</div>
															<div>
																<span>Fecha/Hora de medición</span>
																<p>{evento.fechaMedicion}</p>
															</div>
														</div>

														<button type="button" className="reprocess-detail-card-toggle" onClick={() => toggleSeccionDetalle(evento.idSicbs, "observacion")}>
															<span>Observación</span>
															<i className={`ico-chevron-down ${observacionAbierta ? "is-open" : ""}`} aria-hidden="true"></i>
														</button>
														{observacionAbierta && (
															<p className="reprocess-detail-observation">{evento.observacion || "Lorem ipsum dolor sit amet consectetur."}</p>
														)}

														<button type="button" className="reprocess-detail-card-toggle" onClick={() => toggleSeccionDetalle(evento.idSicbs, "solicitud")}>
															<span>Solicitud</span>
															<i className={`ico-chevron-down ${solicitudAbierta ? "is-open" : ""}`} aria-hidden="true"></i>
														</button>
														{solicitudAbierta && (
															<div className="reprocess-detail-request">
																<div className="reprocess-detail-request__head">
																	<span></span>
																	<strong>De origen</strong>
																	<strong>Solicitado</strong>
																</div>
																<div className="reprocess-detail-request__row">
																	<span className="reprocess-detail-request__icon">{renderActionIcon("receipt")}</span>
																	<div>
																		<small>Estado de evento</small>
																		<span className={`reprocess-status ${obtenerClaseEstado(evento.estadoEventoOrigen)}`}>{evento.estadoEventoOrigen}</span>
																	</div>
																	<div>
																		<small>Estado de evento</small>
																		<span className={`reprocess-status ${obtenerClaseEstado(evento.estadoEventoSolicitado)}`}>{evento.estadoEventoSolicitado}</span>
																	</div>
																</div>
																<div className="reprocess-detail-request__row">
																	<span className="reprocess-detail-request__icon">{renderActionIcon("square-check")}</span>
																	<div>
																		<small>Estado de autorización</small>
																		<span className={`reprocess-status ${obtenerClaseEstado(evento.estadoAutorizacionOrigen)}`}>{evento.estadoAutorizacionOrigen}</span>
																	</div>
																	<div>
																		<small>Estado de autorización</small>
																		<span className={`reprocess-status ${obtenerClaseEstado(evento.estadoAutorizacionSolicitado)}`}>{evento.estadoAutorizacionSolicitado}</span>
																	</div>
																</div>
															</div>
														)}
													</article>
												);
											})}
										</div>
									</>
								) : (
									<div className="reprocess-detail-document">
										<div>
											<strong>Sin Eventos</strong>
											<p>No existen eventos para esta solicitud.</p>
										</div>
									</div>
								)}
							</>
						)}
					</section>
				</div>
			</Modal.Body>
		</Modal>
		</>
	);
};

export default SolicitudReprocesosPage;
